<template>
  <m-elevation :level="4" transition class="app-form-buscador-filtro">
    <m-layout-grid>
      <m-layout-grid-inner>
        <!-- <m-layout-grid-cell :span="12" class="app-form__title"
          >!Encuentra!</m-layout-grid-cell
        > -->
        <m-layout-grid-cell :span="12" class="app-form__title"
          >Consulta nuestros inmuebles en Andalucía</m-layout-grid-cell
        >
        <m-layout-grid-cell :span="12">
          <m-select
            v-model="tipoBienSelect.valueSelected"
            id="tipobien-select"
            outlined
          >
            <option
              v-for="option in tipoBienSelect.options"
              :key="option.text"
              :value="option.value"
              :selected="tipoBienSelect.valueSelected === option.value"
            >
              {{ option.text }}
            </option>
            <m-floating-label slot="label" for="tipobien-select">
              {{ tipoBienSelect.label }}
            </m-floating-label>
          </m-select>
        </m-layout-grid-cell>
        <m-layout-grid-cell :span="12">
          <m-select
            v-model="provinciaSelect.valueSelected"
            id="provincia-select"
            outlined
          >
            <option
              v-for="option in provinciaSelect.options"
              :key="option.text"
              :value="option.value"
              :selected="provinciaSelect.valueSelected === option.value"
            >
              {{ option.text }}
            </option>
            <m-floating-label slot="label" for="provincia-select">
              {{ provinciaSelect.label }}
            </m-floating-label>
          </m-select>
        </m-layout-grid-cell>
        <m-layout-grid-cell :span="12">
          <m-text-field
            v-model="municipio"
            id="textfield-municipio"
            outlined
            v-on:keyup.native.enter="routeToInmuebles()"
          >
            <m-floating-label for="textfield-municipio"
              >Municipio</m-floating-label
            >
          </m-text-field>
        </m-layout-grid-cell>
        <m-layout-grid-cell :span="12">
          <m-button raised @click="routeToInmuebles()">
            Buscar
          </m-button>
        </m-layout-grid-cell>
      </m-layout-grid-inner>
    </m-layout-grid>
  </m-elevation>
</template>

<script>
import AppMixinAnalytics from "@/components/AppMixinAnalytics.js";

export default {
  name: "app-portada-buscador-filtro",
  mixins: [AppMixinAnalytics],
  data() {
    return {
      tipoBienSelect: {
        label: "Tipo de Bien",
        valueSelected: "",
        options: [
          { text: "", value: "" },
          { text: "Suelo residencial", value: "suelo residencial" },
          { text: "Suelo industrial", value: "suelo industrial" },
          { text: "Suelo terciario", value: "suelo terciario" },
          { text: "Suelo dotacional", value: "suelo dotacional" },
          { text: "Parcela aparcamiento", value: "PARCELA APARCAMIENTO" },
          { text: "Suelo urbanizable", value: "SUELO URBANIZABLE" },
          { text: "Suelo no urbanizable", value: "SUELO NO URBANIZABLE" },
          { text: "Locales", value: "locales" },
          { text: "Trasteros", value: "trasteros" },
          { text: "Garajes", value: "garajes" },
          { text: "Naves industriales", value: "naves industriales" },
          { text: "Viviendas", value: "vivienda" }
        ]
      },
      provinciaSelect: {
        label: "Provincia",
        valueSelected: "",
        options: [
          { text: "", value: "" },
          { text: "Almería", value: "almeria" },
          { text: "Cádiz", value: "cadiz" },
          { text: "Córdoba", value: "cordoba" },
          { text: "Granada", value: "granada" },
          { text: "Huelva", value: "huelva" },
          { text: "Jaén", value: "jaen" },
          { text: "Málaga", value: "malaga" },
          { text: "Sevilla", value: "sevilla" }
        ]
      },
      municipio: ""
    };
  },
  methods: {
    routeToInmuebles() {
      var inmueblesRoute = this.routeToViewWithFilter("inmuebles-list");

      this.sendAnalyticsEventWithQueryInfo(
        "click_en_portada_buscador_con_filtro",
        inmueblesRoute.query
      );

      this.$router.push(inmueblesRoute);
    },
    routeToViewWithFilter(routeName) {
      var queryParams = {};

      if (this.tipoBienSelect.valueSelected) {
        queryParams["tipo_bien"] = this.tipoBienSelect.valueSelected;
      }

      if (this.provinciaSelect.valueSelected) {
        queryParams["provincia"] = this.provinciaSelect.valueSelected;
      }

      if (this.municipio) {
        queryParams["municipio"] = this.municipio.trim().toLowerCase();
      }

      return { name: routeName, query: queryParams };
    }
  }
};
</script>

<style lang="scss">
@import "@material/layout-grid/mdc-layout-grid.scss";

.app-form-buscador-filtro {
  max-width: 400px;
  margin: auto;
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 30px;

  .mdc-button {
    width: 100%;
    height: 56px;
    font-size: 1em;
  }

  .mdc-select {
    width: 100%;
    font-size: 1em;

    select.mdc-select__native-control {
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }

    .mdc-select__dropdown-icon {
      top: 13px;
    }
    .mdc-floating-label {
      top: 13px;
      font-size: 1em;
    }
  }

  .mdc-text-field {
    width: 100%;

    input.mdc-text-field__input {
      font-size: 1em;
      // height: 46px;
    }

    .mdc-floating-label {
      font-size: 1em;
    }

    .mdc-notched-outline {
      // height: 46px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }
}

.app-form__title {
  font-size: 1.6em;
  font-weight: bold;
  color: #263238;
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
  .app-form__title {
    font-size: 2em;
  }
}
</style>
